import createClient from '../../apolloClient';
import MUTATION_REASSIGN_ESIM from '../../mutation/reassignEsim';

const handleReassignEsim = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_REASSIGN_ESIM,
    variables,
  });
  const { reassignEsim } = result?.data || {};
  return reassignEsim;
};

export default handleReassignEsim;
